/**
 * Manage scratchpad talkthrough playback
 */
import _ from "underscore";

import $ from "#jquery/jquery-with-scratchpad-plugins.js";

const bindEvents = _.once(function (ScratchpadUI) {
    $(ScratchpadUI).bind({
        beforeunload: function (e, options) {
            if (options.warnMsg && ScratchpadUI.liveEditor?.record.playing) {
                options.warnMsg = undefined;
            }
        },

        remove: function () {
            // Stop play back and destroy the audio track object.
            if (ScratchpadUI.liveEditor?.player) {
                ScratchpadUI.liveEditor.player.destruct();
                ScratchpadUI.liveEditor.record.stopPlayback();
            }

            ScratchpadUI.liveEditor.recordHandlersBound = false;
        },
    });
});

export default {bindEvents};
